import React, { Component } from 'react'
import { $references } from 'services/LegislationReferenceService'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import connect from 'front-end-core/decorators/connect'
import LegislationReferenceComponentContainer from 'redux/containers/components/legislation-reference/LegislationReferenceComponentContainer'

@connect(
  () => ({
    feed: $references
  }),
  {
    feed: { references: RESPONSE_PENDING, title: 'Loading...' }
  }
)
class LegislationReference extends Component {
  render () {
    return (
      <LegislationReferenceComponentContainer {...this.props} />
    )
  }
}

export default LegislationReference
